module.exports = __webpack_public_path__ + "img/icon-arrow-right-circle.b6b55d7c.svg";